import { DataModel } from "common/models/utility-models/base-model";
import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";

export class ApplicantsModel extends DataModel {}

export class ApplicationGridParams extends GridPostParams {
    statusFlag:any=0;
    region_search:string='';
    state_search:string='';
    gender_search:string='';
    department_search:string=''
}

export class ApplicantsGridModel extends ApplicantsModel {}

export class ApplicantsListingModel extends GridModel<ApplicantsGridModel> {}